function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3 20.236c5.523 0 10-4.477 10-10s-4.477-10-10-10c-5.522 0-10 4.477-10 10s4.478 10 10 10zM7.508 6.029a1 1 0 00-1.415 1.414l2.793 2.793-2.793 2.793a1 1 0 101.415 1.414L10.3 11.65l2.793 2.793a1 1 0 101.415-1.414l-2.793-2.793 2.793-2.793a1 1 0 00-1.415-1.414L10.3 8.822 7.508 6.029z",
  fill: "#fff"
})));